var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container order-list" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            { staticClass: "sForm" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    id: "searchForm",
                    "label-width": "70px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入商品名称",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.goodsName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "goodsName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "下单用户", prop: "userInfo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入下单用户",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.userInfo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "userInfo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.userInfo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人", prop: "postUserInfo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "收货人信息",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.postUserInfo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "postUserInfo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.postUserInfo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入订单编号",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "orderNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "售后编号", prop: "afterNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入售后编号",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.afterNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "afterNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.afterNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "售后类型", prop: "orderType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择售后类型",
                            size: "small",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.afterType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "afterType", $$v)
                            },
                            expression: "searchForm.afterType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.platform_order_after_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "售后状态", prop: "orderType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择售后状态",
                            size: "small",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.afterStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "afterStatus", $$v)
                            },
                            expression: "searchForm.afterStatus",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.platform_order_after_status,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间", prop: "createdTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          size: "small",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                        },
                        model: {
                          value: _vm.searchForm.createdTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "createdTime", $$v)
                          },
                          expression: "searchForm.createdTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型", prop: "orderType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择订单类型",
                            size: "small",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.orderType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "orderType", $$v)
                            },
                            expression: "searchForm.orderType",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.platform_order_type,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "btn-list tabclass" }, [
            _c("h3", [_vm._v("数据列表")]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.exportLoading,
                      icon: "el-icon-upload2",
                    },
                    on: { click: _vm.lotsExport },
                  },
                  [_vm._v("批量导出")]
                ),
              ],
              1
            ),
          ]),
          _c("orders-list-table", {
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columnCommon.config,
              typeStr: "afterOrder",
            },
            on: { tableSelectionChange: _vm.handleSelectionChange },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.pageNo,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }